import { useRef } from "react";
import { useDialogFocus } from "../useDialogFocus";

interface ComicActionDialogProps {
  title: string;
  description: string;
  confirmLabel: string;
  onCancel: () => void;
  onConfirm: () => void;
  children?: React.ReactNode;
}

export function ComicActionDialog({
  title,
  description,
  confirmLabel,
  onCancel,
  onConfirm,
  children,
}: ComicActionDialogProps) {
  const cancelRef = useRef<HTMLButtonElement>(null);
  const dialogRef = useRef<HTMLElement>(null);
  useDialogFocus(dialogRef, cancelRef, onCancel);
  return (
    <div className="dialog-backdrop" role="presentation" onMouseDown={onCancel}>
      <section
        aria-describedby="comic-action-description"
        aria-labelledby="comic-action-title"
        aria-modal="true"
        className="comic-dialog"
        onMouseDown={(event) => event.stopPropagation()}
        ref={dialogRef}
        role="alertdialog"
      >
        <h2 id="comic-action-title">{title}</h2>
        <p id="comic-action-description">{description}</p>
        {children}
        <div className="comic-dialog__actions">
          <button
            className="button button--secondary"
            onClick={onCancel}
            ref={cancelRef}
            type="button"
          >
            Cancel
          </button>
          <button className="button button--danger" onClick={onConfirm} type="button">
            {confirmLabel}
          </button>
        </div>
      </section>
    </div>
  );
}
